import { jsx as _jsx } from "react/jsx-runtime";
import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { updateURLWith } from '../../util/url-query-params';
import { getValidAccessToken } from '../../volunteer-service/rest/create-rest-context';
const isAuthenticated = () => {
    const params = new URLSearchParams(window.location.search);
    const isAuth = params.get('is_authenticated');
    return isAuth === '1';
};
const renderVolunteerForm = (elements) => () => [...elements]
    .map((e) => {
    var _a, _b;
    return ({
        root: ReactDOM.createRoot(e),
        volunteerApiUri: (_a = e.getAttribute('data-volunteer-api-uri')) !== null && _a !== void 0 ? _a : '',
        labels: JSON.parse((_b = e.getAttribute('data-labels')) !== null && _b !== void 0 ? _b : '{}'),
    });
})
    .filter(({ volunteerApiUri }) => volunteerApiUri.length > 0)
    .forEach(({ root, volunteerApiUri, labels }) => {
    root.render(_jsx(React.StrictMode, { children: _jsx(App, { volunteerApiUri: volunteerApiUri, labels: labels }) }));
});
const onCloseDialog = (el) => (e) => {
    e.preventDefault();
    updateURLWith({ remove: ['is_authenticated'] }, false);
    axios({
        method: 'get',
        url: `${el.getAttribute('data-sign-out-url')}`,
    }).then(() => window.location.reload());
};
const showDialog = () => [...document.querySelectorAll('.js-press-on-dom-loaded-is-authenticated')]
    .map((e) => {
    var _a;
    return ({
        element: e,
        dialogId: `${(_a = e === null || e === void 0 ? void 0 : e.dataset) === null || _a === void 0 ? void 0 : _a.open}`,
    });
})
    .filter(({ dialogId }) => dialogId && dialogId.length > 0)
    .forEach(({ element, dialogId }) => {
    const formElements = () => [...document.querySelectorAll(`#${dialogId} .js-volunteer-form`)]
        .filter((e) => e.children.length === 0)
        .filter((e) => { var _a; return ((_a = e.getAttribute('data-sign-out-url')) !== null && _a !== void 0 ? _a : '').length > 0; })
        .map((e) => {
        var _a;
        (_a = e.closest('dialog')) === null || _a === void 0 ? void 0 : _a.addEventListener('close', onCloseDialog(e));
        return e;
    });
    element.addEventListener('click', renderVolunteerForm(formElements()));
    element.click();
    element.remove();
});
document.addEventListener('DOMContentLoaded', () => {
    getValidAccessToken()
        .then(() => {
        if (isAuthenticated()) {
            showDialog();
        }
    })
        .catch(() => { }); //TODO: handle not authenticated
});
